<template>
  <div class="d-flex-column-center hover-pointer" @click="$emit('click')">
    <Transition name="fade" mode="out-in">
      <FontAwesomeIcon
        :key="new Date().getTime()"
        :style="style"
        class="select-chapter-button fa-2x"
        :icon="icon"
      />
    </Transition>
  </div>
</template>

<script>
export default {
  props: {
    selected: Boolean,
  },
  data() {
    return {
      styles: new Map([
        [
          'true',
          {
            '--fa-secondary-color': 'var(--bs-primary)',
            '--fa-primary-color': 'var(--bs-quaternary)',
            '--fa-primary-opacity': '1',
            '--fa-secondary-opacity': '1',
          },
        ],
        [
          'false',
          {
            '--fa-secondary-color': 'var(--bs-primary)',
            '--fa-primary-color': 'transparent',
            '--fa-primary-opacity': '1',
            '--fa-secondary-opacity': '1',
          },
        ],
      ]),
    }
  },
  computed: {
    icon() {
      return this.selected ? ['fad', 'check-circle'] : ['fad', 'circle']
    },
    style() {
      return this.selected ? this.styles.get('true') : this.styles.get('false')
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0.8;
}
</style>
